import { Pipe, PipeTransform } from '@angular/core';

const MINUTES = 60 * 1000;
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const MINUTES_30 = 30 * MINUTES;

@Pipe({
  name: 'datesHaveBiggerGap',
  standalone: true,
})
export class DatesHaveBiggerGapPipe implements PipeTransform {
  public transform(date: string | Date, otherDate: string | Date, gap: '30-min' = '30-min'): boolean {
    const firstDate = new Date(date);
    const secondDate = new Date(otherDate);

    if (gap === '30-min') {
      return Math.abs(firstDate.getTime() - secondDate.getTime()) > MINUTES_30;
    }

    return false;
  }
}
